import useSWR, { SWRConfiguration } from 'swr'
import { toast } from 'react-toastify'
import { useMemo, useState } from 'react'
import { learningApi } from '../../../services/api'
import { useDebouncedState } from '../../../hooks/use-debounced-state'
import { TQuestionBook } from '../../Questions/components/QuestionsContent/types'

export function useGetQuestionBooks() {
  const [order, setOrder] = useState<'new' | 'old'>('new')
  const [search, setSearch] = useDebouncedState('', 500)

  const token = localStorage.getItem('token')

  const key = token ? `/question/books` : null

  const swr = useSWR<TQuestionBook[]>(key, fetcher(token), configuration)

  const data = useMemo(() => {
    if (order === 'new' && !search) return swr.data

    let newData = [...swr.data]

    if (search) {
      newData = swr.data.filter((item) =>
        item.name.trim().toLowerCase().includes(search.trim().toLowerCase())
      )
    }

    if (order === 'old') {
      newData.sort(older)
    }

    return newData
  }, [swr.data, order, search])

  const setSearchProxy = (value: string) => {
    const removeSpecialCharacterRegex = /[^\p{L}\p{N}\s]/gu

    setSearch(value.replace(removeSpecialCharacterRegex, ''))
  }

  return { swr, data, params: { setOrder, setSearch: setSearchProxy } }
}

const fetcher = (token: string) => (url: string) =>
  learningApi
    .get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => res.data)

const configuration: SWRConfiguration = {
  fallbackData: [],
  shouldRetryOnError: true,
  onErrorRetry: (error, key, config, revalidate, { retryCount }) => {
    if (retryCount > 3) {
      toast.error(
        'Não foi possível carregar seus cadernos de questões. Tente novamente mais tarde.'
      )
    } else {
      setTimeout(() => revalidate({ retryCount }), 1000)
    }
  },
  dedupingInterval: 60e3,
  revalidateOnReconnect: true,
}

const older = (a: TQuestionBook, b: TQuestionBook) =>
  a.updatedAt < b.updatedAt ? -1 : a.updatedAt > b.updatedAt ? 1 : 0
